<template>
  <sidebar-menu style="max-width: 700px" id="sidebarViewer" :menu="menu" :theme="theme">
    <span slot="toggle-icon">Réduire/Agrandir</span>
  </sidebar-menu>
</template>

<script>
import MapCommentConsultation from './MapCommentConsultation'

export default {
  name: 'SideBarMapComment',
  data() {
    return {
      menu: [{
          component: MapCommentConsultation,
          hiddenOnCollapse: true
        }
      ],
      theme: 'white-theme'
    }
  }
}
</script>
<style>
#sidebarViewer {
  position: relative;
  float: right;
  height: 87%;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/sideBarMapComment/SideBarMapComment.vue